import axios from 'axios';
import { toast } from 'react-toastify';

const language = localStorage.getItem('admin_lang') || 'en';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Accept': 'application/json',
    'language': language,
  },
});

const isPartnerRoute = () => {
  const path = window.location.pathname;
  return path.includes('/partner/') || path.includes('/partner/');
};

const getAuthToken = () => {
  if (isPartnerRoute()) {
    const partner = localStorage.getItem('partner');
    return partner ? JSON.parse(partner).auth_token : null;
  }
  const admin = localStorage.getItem('admin');
  return admin ? JSON.parse(admin).auth_token : null;
};

const handleUnauthorized = () => {
  if (isPartnerRoute()) {
    localStorage.removeItem('partner');
    window.location.href = process.env.REACT_APP_BASE_PATH + '/partner/login';
  } else {
    localStorage.removeItem('admin');
    window.location.href = process.env.REACT_APP_BASE_PATH + '/admin/login';
  }
};

const ApiService = {
  async request({ method, url, data, params, headers = {} }) {
    const token = getAuthToken();

    const mergedHeaders = {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    };

    // Let axios set the correct multipart boundary automatically.
    // Setting null explicitly overrides the axios instance default (application/json)
    // so the XHR adapter removes it and lets the browser set the boundary.
    if (data instanceof FormData) {
      mergedHeaders['Content-Type'] = null;
    }

    const config = {
      method,
      url,
      headers: mergedHeaders,
    };

    if (params) {
      config.params = params;
    } else if (method === 'GET' && data) {
      config.params = data;
    } else if (data) {
      config.data = data;
    }

    try {
      return await apiClient(config);
    } catch (error) {
      if (error.response) {
        const { status, data: responseData } = error.response;

        if (status === 401) {
          toast.error(responseData.message);
          handleUnauthorized();
        } else if (status === 500) {
          toast.error('An internal server error occurred.');
        } else if (status === 422) {
          toast.error(responseData.message);
        } else {
          toast.error(responseData.message);
        }
      } else if (error.request) {
        toast.error('Network error: Please try again later.');
      } else {
        toast.error('An error occurred: ' + error.message);
      }

      throw error;
    }
  },
};

export default ApiService;
